module.exports = __webpack_public_path__ + "img/vuexy-logos.14bb200a.png";